export default {
  root: {
    "&.MuiMenu-paper": {
      marginTop: "2.7rem"
    }
  }
};
